export enum LoadedStatus {
    NotLoaded = -1,
    Pending = 0,
    Loaded = 1
}
